import { render, staticRenderFns } from "./coupSend.vue?vue&type=template&id=9d48e882&"
import script from "./coupSend.vue?vue&type=script&lang=js&"
export * from "./coupSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports